import { DataTable } from 'primereact/datatable';
import classes from './ExtraDustyProducts.module.scss';
import { Column } from 'primereact/column';
import { useExtraDustyProducts } from './useExtraDustyProducts';
import { observer } from 'mobx-react';

const ExtraDustyProducts = () => {
  const { isLoading, extraDustyProducts } = useExtraDustyProducts();

  return (
    <div className={classes.extraDustyProducts}>
      <div className={classes.tableHeader}>
        <h2 className={classes.sectionTitle}>Extra Dusty Products</h2>
      </div>
      <DataTable
        showGridlines
        stripedRows
        emptyMessage="No records found"
        className={classes.dataTable}
        loading={isLoading}
        value={extraDustyProducts}
      >
        <Column field="concept_code" header="Concept Code" />
        <Column field="dosage_form" header="Dosage Form" />
        <Column field="proprietary_name" header="Proprietary Name" />
        <Column field="strength" header="Strength" />
      </DataTable>
    </div>
  );
};

export default observer(ExtraDustyProducts);
